import EmailSettingsRecord from 'records/emailSettings';
import { collectionReducer } from 'utils/reducerGenerator';

export const { reducer, types } = collectionReducer({
    namespace: 'EMAIL_SETTING',
    transformer: EmailSettingsRecord,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/emailSettings/reducer.js